import { gql } from "apollo-boost"

export const GET_PROJECT_BENEFICIARIES_WITH_ATTENDANCE = gql`
  query ProjectBeneficiariesWithAttendance(
    $submissionId: ID!
  ){
    ProjectBeneficiariesWithAttendance(
      submissionId: $submissionId
    )
  }
  `